<template>
  <div class="opple-config-topBar">
    <div
      v-if="showDelete"
      class="opple-config-topBar_selectAll"
      :title="selectTypeMode === 1 ? $t('scene.allno') : $t('scene.all')"
      @click="selectAll"
    >
      {{ selectTypeMode === 1 ? $t('scene.allno') : $t('scene.all') }}
    </div>
    <div
      v-if="showDelete"
      class="opple-config-topBar_delete"
      :title="$t('scene.dele')"
      @click="onDeleteDevice"
    >
      <i v-if="isDeleteLoading" class="el-icon-loading" />
      <i v-else class="el-icon-delete" />
      <span>{{ $t('scene.dele') }}</span>
    </div>
    <div
      v-if="showCancel"
      class="opple-config-topBar_cancel"
      :title="$t('scene.cancel')"
      @click="onCancel"
    >
      {{ $t('scene.cancel') }}
    </div>
    <div
      v-if="showAdd && !showCancel"
      class="opple-config-topBar_add"
      :class="addDisable?'opple-config-topBar_add_disbale':''"
      :title="$t('adddevice.add')"
      @click="showDeviceDialog "
    >
      + {{ $t('adddevice.add') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OppleConfigTopBar',
  components: {},
  props: {
    isDeleteLoading: {
      type: Boolean,
      default: false,
    },
    selectTypeMode: {
      type: Number,
      default: 1,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
    // add按钮是否禁用
    addDisable: {
      type: Boolean,
      default: false,
    },
    // 是否显示取消按钮
    showCancel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  computed: {},

  watch: {},

  mounted() {
    // this.deviceCardList = []
  },

  methods: {
    selectAll() {
      this.$emit('selectAll')
    },
    showDeviceDialog() {
      if(this.addDisable) return
      this.$emit('showDeviceDialog')
    },
    onDeleteDevice() {
      if (this.isDeleteLoading) return
      console.log('onDeleteDevice onDeleteDevice')

      this.$emit('deleteDevice')
    },
    onCancel(){
      this.$emit('onCancel')
    }
  },
}
</script>

<style lang="scss">
.opple-config-topBar {
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding: 10px 10px 20px;
  align-items: center;
  gap: 20px;

  & > div {
    flex-shrink: 0;
    white-space: nowrap;
    cursor: pointer;
  }

  &_delete {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 15px;
    border: 1px solid #1b45a4;
    border-radius: 4px;
    color: #1b45a4;
    line-height: 1;
  }
  &_cancel {
    padding: 0 10px;
    color: #525252;
  }

  .opple-config-topBar_add_disbale{
    color: gray;
    cursor: not-allowed;
  }
}
</style>
